import React, { useState } from "react";
import {
  Container,
  Grid,
  Typography,
  Box,
  Input,
  InputAdornment,
  IconButton,
  Link,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useContactUsMutation } from "../../../../Redux/apis/ApiSlice";
import { notification } from "antd";
import quicktixlogo from "../../../../Images/GX_Logo_White_No_Bg.png";
import appstore from "../../../../Images/appstore.png";
import googleplay from "../../../../Images/playstore.png";
import { SendArrow } from "../../../../Svg/icons";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
const Footer = () => {
  const navigate = useNavigate();
  const [sendContactEmail] = useContactUsMutation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSubscribe = async () => {
    if (!email) {
      notification.error({
        message: "Please enter your email!",
      });
      return;
    }
    setLoading(true);
    try {
      await sendContactEmail({
        name: "",
        email,
        message: "You Just Subscribed!",
      });
      notification.success({
        message:
          "Thank you for Subscribing!",
      });
      setEmail("");
    } catch (error) {
      notification.error({
        message: error.data?.message || "Failed to send the message!",
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box sx={footerStyles.footer}>
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 8 }} sx={{ py: 5 }}>
          {/* Logo & Description */}
          <Grid item xs={12} sm={6} md={4}>
            <Box onClick={() => navigate("/")}>
              {" "}
              <img src={quicktixlogo} alt="Quicktix" height="80" />{" "}
            </Box>
            <Typography sx={footerStyles.description}>
              GX Tickets is an innovative event management platform enabling
              users to book events, create tickets, and promote their events
              globally.
            </Typography>
            <Box sx={footerStyles.socialIcons}>
              <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                <Link
                  href="https://www.facebook.com/share/1B1ueUZsqi/?mibextid=wwXIfr"
                  target="_blank"
                  sx={footerStyles.iconLink}
                >
                  <FacebookIcon sx={{ color: "#535353" }} />
                </Link>
                <Link
                  href="https://www.instagram.com/gxtickets?igsh=MW1sbDhvbW4xczYyYw=="
                  target="_blank"
                  sx={footerStyles.iconLink}
                >
                  <InstagramIcon sx={{ color: "#535353" }} />
                </Link>
                <Link
                  href="https://www.linkedin.com/company/gxtickets/"
                  target="_blank"
                  sx={footerStyles.iconLink}
                >
                  <LinkedInIcon sx={{ color: "#535353" }} />
                </Link>
                <Link
                  href="https://www.youtube.com/@GXTickets"
                  target="_blank"
                  sx={footerStyles.iconLink}
                >
                  <YouTubeIcon sx={{ color: "#535353" }} />
                </Link>
              </Box>
            </Box>
          </Grid>
          {/* Download App & Subscribe */}
          <Grid item xs={12} sm={4} md={4}>
            <Typography sx={footerStyles.heading}>Download App</Typography>
            <Box sx={footerStyles.appIcons}>
              <a
                href="https://apps.apple.com/pk/app/gx-tickets/id6745892471"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/images/app-store1.svg"
                  alt="App Store"
                  height="40"
                  style={footerStyles.iconStyle}
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.npisoftware.gxtickets&pli=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/images/play-store1.svg"
                  alt="Google Play"
                  height="40"
                  style={footerStyles.iconStyle}
                />
              </a>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Typography sx={footerStyles.heading}>Subscribe</Typography>
              <Input
                placeholder="Email here"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={footerStyles.input}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={handleSubscribe} disabled={loading}>
                      {loading ? (
                        <CircularProgress size={24} sx={{ color: "white" }} />
                      ) : (
                        <SendArrow sx={{ color: "white" }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </Box>
          </Grid>
          {/* Quick Links */}
          <Grid item xs={6} sm={2} md={4}>
            <Typography sx={footerStyles.heading}>Quick Links</Typography>
            <Link sx={footerStyles.link} onClick={() => navigate("/contact")}>
              Contact Us
            </Link>
            <Link sx={footerStyles.link} onClick={() => navigate("/about-us")}>
              About Us
            </Link>
            <Link sx={footerStyles.link} onClick={() => navigate("/login")}>
              Log in
            </Link>
            <Link href="/terms-conditions" sx={footerStyles.link}>
              Terms & Conditions
            </Link>
            <Link href="/privacy-policy" sx={footerStyles.link}>
              Privacy Policy
            </Link>
          </Grid>
        </Grid>
      </Container>
      {/* Copyright Section */}
      <Box sx={footerStyles.copyrightContainer}>
        <Typography sx={footerStyles.copyrightText}>
          &copy; 2024 GX Tickets. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};
export default Footer;
const footerStyles = {
  footer: {
    backgroundColor: "var(--primary-color)",
    color: "#fff",
    textAlign: "left",
  },
  description: {
    fontSize: "14px",
    fontWeight: 400,
    marginTop: 2,
    textAlign: "justify",
    hyphens: "auto",
  },
  heading: {
    fontSize: "16px",
    fontWeight: 700,
    marginBottom: "10px",
  },
  link: {
    display: "block",
    fontSize: "14px",
    fontWeight: 400,
    color: "#fff",
    textDecoration: "none",
    cursor: "pointer",
    marginBottom: "6px",
    "&:hover": { textDecoration: "underline" },
  },
  appIcons: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  iconStyle: {
    border: "1px solid grey",
    borderRadius: "4px",
  },
  input: {
    width: "100%",
    color: "white",
    borderBottom: "1px solid white",
    "&::placeholder": { color: "white" },
  },
  socialIcons: {
    marginTop: "10px",
    display: "flex",
    gap: "10px",
  },
  icon: {
    color: "white",
  },
  copyrightContainer: {
    textAlign: "center",
    padding: "12px 0",
    borderTop: "1px solid #ffffff33",
    marginTop: "20px",
  },
  copyrightText: {
    fontSize: "12px",
    fontWeight: 400,
  },
};
